/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Page routes are defined here
 */
const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  LOGIN_REDIRECT: '/login-callback',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFY_CALLBACK: '/verify-callback',
  DASHBOARD: '/dashboard',
  VISUAL_FILTER: '/visual-filter',
  EVENT_CONFIGURATION: '/event-configuration',
  USER_INVITATION: '/user-invitation',
  AUDIT_LOGS: '/audit-logs',
  USERS: '/users',
  HOTELS: '/hotels',
  NOT_FOUND: '*',
  HOTEL_SET: '/hotel-set',
  TRANSACTIONS: '/transactions',
  SYSTEM: '/system',
  SCENARIO:'/scenarios',
  PLATFORM_ADMIN_SETTINGS: '/platform-admin-settings',
  LLM_STATISTICS: '/llm-statistics',
};
//
export default ROUTES;
